import { memo } from "react";
import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../../theme/palette";
import { View } from "../../View";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    padding: "16px",
    marginTop: "10px",
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const EditDriverModalActions = memo(
  ({ onSave = () => {}, disabled }) => {
    const styles = useStyles();

    return (
      <View className={styles.container}>
        <Button
          disabled={disabled}
          className={styles.blue}
          variant={"contained"}
          onClick={onSave}
        >
          Save Changes
        </Button>
      </View>
    );
  }
);
